import { RouteLocationNormalizedLoaded } from 'vue-router';
import jumpToAnchor from '@/helpers/article/jumpToAnchor';

const MOST_COMMON_WORDS_ANCHOR = 'most_common_words';

export default function setLinksToMostCommonWords(route: RouteLocationNormalizedLoaded) {
  const hrefs = document.querySelectorAll('[data-link-to]');
  const hrefsArray = Array.from(hrefs);
  hrefsArray.forEach((el) => {
    const anchorUrl = `${route.fullPath.replace(route.hash, '')}#${el.getAttribute('data-link-to')}`;
    if (!(el instanceof HTMLElement)) return;
    el.setAttribute('href', anchorUrl);
    el.onclick = (e) => {
      e.preventDefault();
      window.history.pushState(
        {},
        null as any,
        anchorUrl,
      );
      jumpToAnchor();
    };
  });
}
